<div class="page-header" id="banner">
  <div class="row">
    <div class="col">
      <h1><a routerLink="/fleet">Fleet</a> > Add vehicle</h1>
    </div>
  </div>
</div>

<form #vehicleForm="ngForm">
  <div class="form-group">
    <label for="year">Year</label>
    <input type="number" class="form-control form-control-lg" [class.is-invalid]="yearField.invalid && (yearField.dirty || yearField.touched)"
      id="year" name="year" [(ngModel)]="year" (ngModelChange)="updateName()" placeholder="2024" required #yearField="ngModel">
    @if (yearField.invalid && (yearField.dirty || yearField.touched)) {
      <div class="invalid-feedback">
        @if (yearField.errors.required) {
          <div>Please enter a year.</div>
        }
      </div>
    }
  </div>
  <div class="form-group">
    <label for="make">Make</label>
    <input type="text" class="form-control form-control-lg" [class.is-invalid]="makeField.invalid && (makeField.dirty || makeField.touched)"
      id="make" name="make" [(ngModel)]="make" (ngModelChange)="updateName()" placeholder="Toyota" required #makeField="ngModel">
    @if (makeField.invalid && (makeField.dirty || makeField.touched)) {
      <div class="invalid-feedback">
        @if (makeField.errors.required) {
          <div>Please enter a make.</div>
        }
      </div>
    }
  </div>
  <div class="form-group">
    <label for="model">Model</label>
    <input type="text" class="form-control form-control-lg" [class.is-invalid]="modelField.invalid && (modelField.dirty || modelField.touched)"
      id="model" name="model" [(ngModel)]="model" (ngModelChange)="updateName()" placeholder="Camry" required #modelField="ngModel">
    @if (modelField.invalid && (modelField.dirty || modelField.touched)) {
      <div class="invalid-feedback">
        @if (modelField.errors.required) {
          <div>Please enter a model.</div>
        }
      </div>
    }
  </div>
  <div class="form-group">
    <label for="name">Name</label>
    <input type="text" class="form-control form-control-lg" [class.is-invalid]="nameField.invalid && (nameField.dirty || nameField.touched)"
      id="name" name="name" [(ngModel)]="name" required #nameField="ngModel">
    @if (nameField.invalid && (nameField.dirty || nameField.touched)) {
      <div class="invalid-feedback">
        @if (nameField.errors.required) {
          <div>Please enter a name for the vehicle.</div>
        }
      </div>
    }
  </div>
  <div class="form-group">
    <label for="mileage">Mileage</label>
    <input type="number" class="form-control form-control-lg" [class.is-invalid]="mileageField.invalid && (mileageField.dirty || mileageField.touched)"
      id="mileage" name="mileage" [(ngModel)]="mileage" placeholder="123456" required #mileageField="ngModel">
    @if (mileageField.invalid && (mileageField.dirty || mileageField.touched)) {
      <div class="invalid-feedback">
        @if (mileageField.errors.required) {
          <div>Please enter the current mileage.</div>
        }
      </div>
    }
  </div>
  <div class="form-group">
    <label for="vin">VIN <span class="text-muted">(optional)</span></label>
    <input type="text" class="form-control form-control-lg" [class.is-invalid]="vinField.invalid && (vinField.dirty || vinField.touched)"
      id="vin" name="vin" [(ngModel)]="vin" placeholder="1HGBH41JXMN109186" maxlength="17"
      pattern="[A-HJ-NPR-Z0-9]{17}" #vinField="ngModel">
    @if (vinField.invalid && (vinField.dirty || vinField.touched)) {
      <div class="invalid-feedback">
        @if (vinField.errors?.['pattern']) {
          <div>VIN must be exactly 17 alphanumeric characters (no I, O, or Q).</div>
        }
      </div>
    }
  </div>
  <button class="btn btn-primary" (click)="add()" [disabled]="vehicleForm.invalid">Submit</button>
  <a class="btn" routerLink="/fleet">Cancel</a>
</form>